export { getPath } from './getPath';
export { deletePhoneDividers } from './deletePhoneDividers';

export { transformMinutesToHours } from './transformMinutesToHours';

export { debounce } from '@app/utils/debounce';

export { adaptDataToSelect } from './adaptDataToSelect';
export { adaptDateFromSelects } from './adaptDateFromSelects';
export { addEnterKeyListener } from './addEnterKeyListener';
export { addLeadingZeroes } from './addLeadingZeroes';
export { addUserPrintAsParams } from './addUserPrintAsParams';
export { afterUserUpdate } from './afterUserSaving';
export { capitalizeFirstLetter } from './capitalizeFirstLetter';
export { capitalizeKeys } from './capitalizeKeys';
export { changeStandardPaginationUi } from './changeStandardPaginationUi';
export { checkAppVersionAndClearSessionStorage } from './checkAppVersionAndClearSessionStorage';
export { checkForAllPathEnds } from './checkForAllPathEnds';
export { checkWorkingHours } from './checkWorkingHours';
export { clearSessionStorageAndReload } from './clearSessionStorageAndReload';
export { compareTwoDates } from './compareTwoDates';
export { convertDateFromSelectToISOFormat } from './convertDateFromSelectToISOFormat';
export { correctRangeValues } from './correctRangeValues';
export { correctTimeInterval } from './correctTimeInterval';
export { createId } from './createId';
export { createUserPrint } from './createUserPrint';
export {
  addWsEventListener,
  createWSConnection,
  subscribeToWsEvent,
  subscribeToWsReconnect,
  unregisterWSMethod,
  unsubscribeFromWsEvent,
  disconnectSignalR,
} from './createWSConnection';
export { defineAccessTokenName } from './defineAccessTokenName';
export {
  dropLegacyAccessToken,
  getAccessToken,
  removeAccessToken,
  setAccessToken,
} from './accessTokenStorage';
export { defineDeployingMode } from './defineDeployingMode';
export { defineHostWithProtocol } from './defineHostWithProtocol/defineHostWithProtocol';

export { divideAmount } from './divideAmount';
export { domElementIntoView } from './domElementIntoView';
export { fileToBase64 } from './fileToBase64';
export { findSidebarParentKey } from './findSidebarParentKey';
export { formatBytes } from './formatBytes';
export { formatDate } from './formatDate';
export { formatDateToISOWithLocalTimezone } from './formatDateToISOWithLocalTimezone';
export { formatDateWithNumbersAndDays } from './formatDateWithNumbersAndDays';
export { formatISODateToCustomFormat } from './formatISODateToCustomFormat';
export { generateKey } from './generateKey';
export { generateTimes } from './generateTimes';
export { getBrowserInfo } from './getBrowserInfo';
export { getContrastYIQ } from './getContrastYIQ';
export { getFileImage } from './getFileImage';
export { getIconObjectById } from './getIconObjectById';
export { getOsIcon } from './getOsIcon';
export { getPaginationItemRenderWithDataTestIds } from './getPaginationItemRenderWithDataTestIds';
export { getSelectItemByValue } from './getSelectItemByValue';
export { getStatusColor } from './getStatusColor';
export { getUniqueCategories } from './getUniqueCategories';
export { handleDate } from './handleDate';
export { formatActionText } from './handleHistoryElementHeaderLinks';
export { handleServiceDuration } from './handleServiceDuration';
export { handleTimestamp } from './handleTimestamp';
export { hasRightsToOrgsCrmModule } from './hasRightsToOrgsCrmModule/hasRightsToOrgsCrmModule';
export { hasToken } from './hasToken';
export { importClientServices } from './importClientServices';
export { keysFirstLetterToLower } from './keysFirstLetterToLower';
export { keysToLowerCase } from './keysToLowerCase';
export { logOutUser } from './logOutUser';
export { numericValidator } from './numericValidator';
export { openImportTemplateFile } from './openImportTemplateFile';
export { privateFormatDate } from './privateFormatDate';
export { shortName } from './shortName';
export { showDevNotification } from './showDevNotification';
export { transformBigIntToString } from './transformBigIntToString';
export { transformImportedName } from './transformImportedName';
export { withTestId } from './withTestId';
export { addDataTestIdsToSelectDropdown } from './addDataTestIdsToSelectDropdown';
export { clearBrowserStorage } from './clearBrowserStorage';
export { hardResetRedux } from './hardResetRedux';
export { purgePersistedRedux } from './purgePersistedRedux';
export {
  clearActiveBranchSession,
  getActiveBranchCountryIdFromSession,
  getActiveBranchIdFromSession,
  getActiveBranchNameFromSession,
  getActiveBranchUserIdFromSession,
  setActiveBranchSession,
  subscribeActiveBranchSession,
} from './activeBranchSession';
export { removePlusSign } from './removePlusSign';
export { getMimeTypeByName, buildAudioDownloadName } from './fileHelpers';
export { getSelectOptionsWithDeletedItems } from './getSelectOptionsWithDeletedItems';
export { playLeadsUpdateSound } from './playLeadsUpdateSound';
export { formatStringDateToDayjs } from './formatStringDateToDayjs';
export { formatDayjsToString } from './formatDayjsToString';
